const validateAnswer = function (errors, vm, showTip) {
  const { answerConfig: { requireInd, paramInt01 }, value, otherAnswer } = this
  if (requireInd === '1' && sessionStorage.getItem('descChangeStatus') === '1') {
    if (!value) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    } else if (paramInt01 === '4' && (value && value.split(',').length < Number(paramInt01) - 1)) {
      // 带详细地址
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    } else if(paramInt01 !== '4' && (value && value.split(',').length < Number(paramInt01))) {
      // 不带详细地址
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }
  } else if (requireInd === '0') {
    return true
  }
  if (!value) {
    errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
    return !errors.length
  }
  if (paramInt01 === '4' && !otherAnswer && sessionStorage.getItem('descChangeStatus') === '1') {
    errors.push(vm.$t('详细地址不能为空'))
  }
  
  return !errors.length
}

const validate = function (vm, showTip) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/SelectBox/answerValidate.js